<template>
  <b-modal
    ref="modal"            
    @shown="onShow"
    class="modale"
    :no-close-on-backdrop="true"
  >    
    <div slot="modal-header" style="display:none"/>
      <div class="container-fluid">

        <div class="item">
              <label class="email-input-field noBorder" v-html="_trans('WHERE ARE YOU COOKING FROM?')"/>                  
          </div>
          
          <div class="item">      
              <!-- <div class="item flagContainer"> -->
                <!-- <country-flag country="gb" size='big'/> -->
                <select v-model="selectedShop" class="email-input-field selectedShop" style="color:black" @change="changeSelectedShop(selectedShop)">    
                  <option v-for="shop in countries" :key="shop.country" v-text="shop.country" :value="shop"/>                                                                         
                </select>
              <!-- </div> -->
          </div>  

          <div class="item">
              <label class="email-input-field noBorder small" v-html="_trans('*PRODUCT AVAILABILITY MAY CHANGE DEPENDING ON THE COUNTRY, PLEASE SELECT THE COUNTRY WHERE YOU WILL INSTALL YOUR PRODUCT')"/>                  
          </div>

      </div>
    <div slot="modal-footer">
        <button 
            v-text="_trans('Start Configuring')" 
            class="btn custom-link btnOG border-width-1 btnOG-color-prif btnOG-round btnOG-outline btnOG-icon-left btnOG-ripple-out btnOG-border-animated btn-start btn-lg btn-block buttonSelect"                 
            @click="selectShop()">                
        </button>
    </div>
  </b-modal>
</template>
<script>
    import CountryFlag from 'vue-country-flag'
    import modal from "@dialogs/modal.vue";
    import Cookies from 'js-cookie';
    import { Auth } from '@3cad/nextcore';

    export default {
        mixins: [modal],
        components:{
          CountryFlag
        },
        data() {
            return {
                selectedShop: {} ,               
            };            
        },                 
        computed:{
          countries() {
            return [
                {"country": "Korea","shop":"2 - Officine Gullo srl - Commercial"},
                {"country": "Japan","shop":"2 - Officine Gullo srl - Commercial"},
                {"country": "Australia","shop":"3 - Officine Gullo srl - Commercial"},
                {"country": "New Zealand","shop":"3 - Officine Gullo srl - Commercial"},
                {"country": "Russia","shop":"3 - Officine Gullo srl - Commercial"},
                {"country": "Armenia","shop":"3 - Officine Gullo srl - Commercial"},
                {"country": "Azerbaijan","shop":"3 - Officine Gullo srl - Commercial"},
                {"country": "Belarus","shop":"3 - Officine Gullo srl - Commercial"},
                {"country": "Estonia","shop":"3 - Officine Gullo srl - Commercial"},
                {"country": "Georgia","shop":"3 - Officine Gullo srl - Commercial"},
                {"country": "Kirghizistan","shop":"3 - Officine Gullo srl - Commercial"},
                {"country": "Lettonia","shop":"3 - Officine Gullo srl - Commercial"},
                {"country": "Lituania","shop":"3 - Officine Gullo srl - Commercial"},
                {"country": "Moldova","shop":"3 - Officine Gullo srl - Commercial"},
                {"country": "Tagikistan","shop":"3 - Officine Gullo srl - Commercial"},
                {"country": "Turkmenistan","shop":"3 - Officine Gullo srl - Commercial"},
                {"country": "Ucraine","shop":"3 - Officine Gullo srl - Commercial"},
                {"country": "Uzbekistan","shop":"3 - Officine Gullo srl - Commercial"},
                {"country": "Kazakistan","shop":"3 - Officine Gullo srl - Commercial"},
                {"country": "China","shop":"2 - Officine Gullo srl - Commercial"},
                {"country": "Taiwan","shop":"2 - Officine Gullo srl - Commercial"},
                {"country": "Macau","shop":"2 - Officine Gullo srl - Commercial"},
                {"country": "Hong Kong","shop":"3 - Officine Gullo srl - Commercial"},
                {"country": "Brunei","shop":"2 - Officine Gullo srl - Commercial"},
                {"country": "Cambodia","shop":"2 - Officine Gullo srl - Commercial"},
                {"country": "East Timor","shop":"2 - Officine Gullo srl - Commercial"},
                {"country": "Indonesia","shop":"2 - Officine Gullo srl - Commercial"},
                {"country": "Laos","shop":"2 - Officine Gullo srl - Commercial"},
                {"country": "Malaysia","shop":"2 - Officine Gullo srl - Commercial"},
                {"country": "Myanmar","shop":"2 - Officine Gullo srl - Commercial"},
                {"country": "Philippines","shop":"2 - Officine Gullo srl - Commercial"},
                {"country": "Singapore","shop":"2 - Officine Gullo srl - Commercial"},
                {"country": "Thailand","shop":"2 - Officine Gullo srl - Commercial"},
                {"country": "Vietnam","shop":"3 - Officine Gullo srl - Commercial"},
                {"country": "UAE","shop":"3 - Officine Gullo srl - Commercial"},
                {"country": "Qatar","shop":"3 - Officine Gullo srl - Commercial"},
                {"country": "Lebanon","shop":"3 - Officine Gullo srl - Commercial"},
                {"country": "Kuwait","shop":"3 - Officine Gullo srl - Commercial"},
                {"country": "Saudi Arabia","shop":"3 - Officine Gullo srl - Commercial"},
                {"country": "Turkey","shop":"3 - Officine Gullo srl - Commercial"},
                {"country": "Bahrein","shop":"3 - Officine Gullo srl - Commercial"},
                {"country": "Jordan","shop":"3 - Officine Gullo srl - Commercial"},
                {"country": "Iran","shop":"3 - Officine Gullo srl - Commercial"},
                {"country": "Iraq","shop":"3 - Officine Gullo srl - Commercial"},
                {"country": "Oman","shop":"3 - Officine Gullo srl - Commercial"},
                {"country": "Syria","shop":"3 - Officine Gullo srl - Commercial"},
                {"country": "Yemen","shop":"3 - Officine Gullo srl - Commercial"},
                {"country": "Angola","shop":"3 - Officine Gullo srl - Commercial"},
                {"country": "Botswana","shop":"3 - Officine Gullo srl - Commercial"},
                {"country": "Comoros","shop":"3 - Officine Gullo srl - Commercial"},
                {"country": "Democratic Republic of Congo","shop":"3 - Officine Gullo srl - Commercial"},
                {"country": "Swaziland","shop":"3 - Officine Gullo srl - Commercial"},
                {"country": "Lesotho","shop":"3 - Officine Gullo srl - Commercial"},
                {"country": "Madagascar","shop":"3 - Officine Gullo srl - Commercial"},
                {"country": "Malawi","shop":"3 - Officine Gullo srl - Commercial"},
                {"country": "Mauritius","shop":"3 - Officine Gullo srl - Commercial"},
                {"country": "Mozambique","shop":"3 - Officine Gullo srl - Commercial"},
                {"country": "Namibia","shop":"3 - Officine Gullo srl - Commercial"},
                {"country": "South Africa","shop":"3 - Officine Gullo srl - Commercial"},
                {"country": "Tanzania","shop":"3 - Officine Gullo srl - Commercial"},
                {"country": "Zambia","shop":"3 - Officine Gullo srl - Commercial"},
                {"country": "Zimbabwe","shop":"3 - Officine Gullo srl - Commercial"},
                {"country": "Argentina","shop":"Officine Gullo inc - Commercial"},
                {"country": "Bolivia","shop":"Officine Gullo inc - Commercial"},
                {"country": "Brazil","shop":"Officine Gullo inc - Commercial"},
                {"country": "Chile","shop":"Officine Gullo inc - Commercial"},
                {"country": "Colombia","shop":"Officine Gullo inc - Commercial"},
                {"country": "Costa Rica","shop":"Officine Gullo inc - Commercial"},
                {"country": "Cuba","shop":"Officine Gullo inc - Commercial"},
                {"country": "Dominican Republic","shop":"Officine Gullo inc - Commercial"},
                {"country": "Ecuador","shop":"Officine Gullo inc - Commercial"},
                {"country": "El Salvador","shop":"Officine Gullo inc - Commercial"},
                {"country": "French Guiana","shop":"Officine Gullo inc - Commercial"},
                {"country": "Guatemala","shop":"Officine Gullo inc - Commercial"},
                {"country": "Haiti","shop":"Officine Gullo inc - Commercial"},
                {"country": "Honduras","shop":"Officine Gullo inc - Commercial"},
                {"country": "Mexico","shop":"Officine Gullo inc - Commercial"},
                {"country": "Nicaragua","shop":"Officine Gullo inc - Commercial"},
                {"country": "Panama","shop":"Officine Gullo inc - Commercial"},
                {"country": "Paraguay","shop":"Officine Gullo inc - Commercial"},
                {"country": "Peru","shop":"Officine Gullo inc - Commercial"},
                {"country": "Puerto Rico","shop":"Officine Gullo inc - Commercial"},
                {"country": "Saint Barthelemy","shop":"Officine Gullo inc - Commercial"},
                {"country": "Saint Martin","shop":"Officine Gullo inc - Commercial"},
                {"country": "Uruguay","shop":"Officine Gullo inc - Commercial"},
                {"country": "Venezuela","shop":"Officine Gullo inc - Commercial"},
                {"country": "Antigua and Barbuda","shop":"Officine Gullo inc - Commercial"},
                {"country": "Denmark","shop":"3 - Officine Gullo srl - Commercial"},
                {"country": "Sweden","shop":"3 - Officine Gullo srl - Commercial"},
                {"country": "Finland","shop":"3 - Officine Gullo srl - Commercial"},
                {"country": "Norway","shop":"3 - Officine Gullo srl - Commercial"},
                {"country": "Germany","shop":"3 - Officine Gullo srl - Commercial"},
                {"country": "Austria","shop":"3 - Officine Gullo srl - Commercial"},
                {"country": "ITALIA","shop":"1 - Officine Gullo srl - Commercial"},
                {"country": "Spain","shop":"3 - Officine Gullo srl - Commercial"},
                {"country": "Andorra","shop":"3 - Officine Gullo srl - Commercial"},
                {"country": "France","shop":"3 - Officine Gullo srl - Commercial"},
                {"country": "Belgium","shop":"3 - Officine Gullo srl - Commercial"},
                {"country": "Luxemburg","shop":"3 - Officine Gullo srl - Commercial"},
                {"country": "Monaco","shop":"3 - Officine Gullo srl - Commercial"},
                {"country": "Switzerland","shop":"3 - Officine Gullo srl - Commercial"},
                {"country": "Liechtenstein","shop":"3 - Officine Gullo srl - Commercial"},
                {"country": "UK","shop":"Officine Gullo ltd POUNDS - Commercial"},
                {"country": "Ireland","shop":"Officine Gullo ltd POUNDS - Commercial"},
                {"country": "Croatia","shop":"3 - Officine Gullo srl - Commercial"},
                {"country": "Portugal","shop":"3 - Officine Gullo srl - Commercial"},
                {"country": "Holland","shop":"3 - Officine Gullo srl - Commercial"},
                {"country": "Slovakia","shop":"3 - Officine Gullo srl - Commercial"},
                {"country": "Cyprus","shop":"3 - Officine Gullo srl - Commercial"},
                {"country": "Romania","shop":"3 - Officine Gullo srl - Commercial"},
                {"country": "Poland","shop":"3 - Officine Gullo srl - Commercial"},
                {"country": "Bulgaria","shop":"3 - Officine Gullo srl - Commercial"},
                {"country": "Greece","shop":"3 - Officine Gullo srl - Commercial"},
                {"country": "Hungary","shop":"3 - Officine Gullo srl - Commercial"},
                {"country": "Albania","shop":"3 - Officine Gullo srl - Commercial"},
                {"country": "Bosnia and Herzegovina","shop":"3 - Officine Gullo srl - Commercial"},
                {"country": "Czech Republic","shop":"3 - Officine Gullo srl - Commercial"},
                {"country": "Iceland","shop":"3 - Officine Gullo srl - Commercial"},
                {"country": "Malta","shop":"3 - Officine Gullo srl - Commercial"},
                {"country": "Montenegro","shop":"3 - Officine Gullo srl - Commercial"},
                {"country": "North Macedonia","shop":"3 - Officine Gullo srl - Commercial"},
                {"country": "Serbia","shop":"3 - Officine Gullo srl - Commercial"},
                {"country": "Slovenia","shop":"3 - Officine Gullo srl - Commercial"},
                {"country": "ISRAEL","shop":"3 - Officine Gullo srl - Commercial"},
                {"country": "NIGERIA","shop":"3 - Officine Gullo srl - Commercial"},
                {"country": "INDIA","shop":"3 - Officine Gullo srl - Commercial"},
                {"country": "CANADA","shop":"Officine Gullo inc - Commercial"},
                {"country": "USA NORTH EAST","shop":"Officine Gullo inc - Commercial"},
                {"country": "USA WEST COAST","shop":"Officine Gullo inc - Commercial"},
                {"country": "USA CENTRAL SOUTH","shop":"Officine Gullo inc - Commercial"},
                {"country": "USA SOUTH EAST","shop":"Officine Gullo inc - Commercial"},
                {"country": "TUTTI I PAESI NON COMPRESI SOPRA","shop":"3 - Officine Gullo srl - Commercial"},
            ]
          },
          user() {
            return this.$store.getters['getProfile']
          }
        },           
        methods: {
            changeSelectedShop(e){
                this.selectedShop = e;
            },
            selectShop(){                
                Cookies.set('country',this.selectedShop.country, { expires: 999 }); 
                if(this.selectedShop != this.user.shop){                  
                  Auth.setShop(this.selectedShop.cod).then( newProfile => {
                      this.$store.commit('setProfile', newProfile);
                      this.close(1);
                  });                
                }
            },
            checkCookies() {              
                var cookies = Cookies.get();
                if(cookies.country && this.user.shops.filter(obj =>{ return obj.country == cookies.country}).length > 0){                     
                    this.selectedShop = this.user.shops.filter(obj =>{ return obj.country == cookies.country})[0];
                    return true;
                }             
                else{
                    return false;
                }       
            },
            onShow() {
               if(this.checkCookies()){
                  this.selectShop();
                }
                else {                  
                    this.selectedShop = this.user.shops[0];
                }
            }
        }
    };
</script>
<style scoped lang="scss">
  .close{
    display: none;
  }

  .flagContainer{
    width: 100%;
    height: 100%;
  }

  .btn:hover{
    background-color:#c4a671 !important;;  
  }
  
  @font-face {
      font-family: "Montserrat";
      src: url("../../../scss/fonts/Montserrat/Montserrat-Regular.ttf");
      font-style: normal;
  }
  .flag{
    margin: auto !important;
    float: left !important;
    width: 65px !important;
  }

  .selectedShop{
    margin: auto !important;
    float: left !important;
    height: 41px !important;
  }
 

  .email-input-field{    
    color:white;
    display: block;
    font-size: 14px;
    line-height: initial;
    margin: 9px 0px 0px 0px;
    padding: 10px 15px 10px 15px;
    border-style: solid;
    border-radius: 2px;
    font-weight: normal;
    border: 1px solid #4a4a4a;
    height: 60px;
    width: 100%;
    margin-left: 10px;  
    text-align: center;
    &.noBorder{
      border-style: none;
      border: none;
    }  
    &.small{
      font-size: 10px;
    }
  }


  .item{
    font-family: Montserrat;
  }

  textarea{    
      height: 200px !important;    
  }

  .modal-mask {
    position: fixed;
    z-index: 1040;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.5);
    display: table;
    transition: opacity 0.3s ease;
  }

  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;
  }


  .modal-body {
    margin: 20px 0;
    background-color:#4a4a4a !important;
  }

  .modal-footer{
    background-color: #4a4a4a;
  }

  /*
  * The following styles are auto-applied to elements with
  * transition="modal" when their visibility is toggled
  * by Vue.js.
  *
  * You can easily play with the modal transition by editing
  * these styles.
  */

  .modal-enter {
    opacity: 0;
  }

  .modal-leave-active {
    opacity: 0;
  }

  .modal-enter .modal-container,
  .modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }


  .container {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row-reverse;
    justify-content: center;
    align-items: auto;
    align-content: start
  }

  .item {
    flex: 0 0 auto;
    margin: 8px;
    width: 100%;
    display: inline-flex;
  }

  button.close {
    position: absolute;
    right: 9vw;
    top: 1vh;
    font-size: 40px;
    margin: 0 !important;
  }

  .buttonSelect{
    border: 1px white solid;
    border-radius: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/app/dialogs/modalShopSelector.vue